module.exports = __webpack_public_path__ + "static/media/people5.8591ea7b.jpeg";